<template>
  <v-app>
    <navigation-drawer></navigation-drawer>
    <navigation-bar
        :notifications.sync="notifications"
        :bridgeNotifications.sync="bridgeNotifications"
        @set-notification="setNotification"
        @set-bridge-notification="setBridgeNotification"
    >
    </navigation-bar>
    <!--    <v-dialog v-model="holdMyBeer" :max-width="450" attach-->
    <!--      @click:outside="holdMyBeer = false">-->
    <!--      <v-card>-->
    <!--        <v-card-text class="pt-4">-->
    <!--          <span class="subtitle-1 ">-->
    <!--            14 Şubat'ın sizin için anlamı var mı yok mu bilemiyoruz ama-->
    <!--            {{ user.site.toUpperCase() }}-->
    <!--            olarak sizi çok sevdiğimizi bilmenizi istedik.-->
    <!--          </span>-->
    <!--        </v-card-text>-->
    <!--      </v-card>-->
    <!--    </v-dialog>-->
    <v-main>
      <v-scale-transition>
        <confirmation/>
      </v-scale-transition>
      <feed-back></feed-back>
      <v-container
          fluid
          class="pa-6"
          v-if="bookmark !== 'Genel Bakış'"
      >
        <span
            class="tutbasi"
            v-text="bookmark"
        ></span>
      </v-container>
      <v-slide-x-transition>
        <router-view></router-view>
      </v-slide-x-transition>

      <ChangePasswordDialog/>
    </v-main>
    <v-footer class="pa-3">
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
    <notification-popup/>
  </v-app>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import NavigationDrawer from './Components/NavigationDrawer.vue';
import NavigationBar from './Components/NavigationBar.vue';
import Confirmation from './Components/Confirmation/Confirmation.vue';
import FeedBack from './Components/FeedBack/FeedBack.vue';
import ChangePasswordDialog from './Components/ChangePasswordDialog.vue';
import NotificationPopup from '@/views/Components/Notification/NotificationPopup';

export default {
  name: 'DashboardLayout',
  components: {
    NotificationPopup,
    FeedBack,
    Confirmation,
    NavigationBar,
    NavigationDrawer,
    ChangePasswordDialog,
  },
  methods: {
    ...mapActions({ send: 'asyncSender' }),
    ...mapMutations({ setPopup: 'setNotificationPopup' }),
    getNotifications() {
      const route = 'notifications/unread';

      this.send({ route })
          .then((res) => {
            this.notifications = res.data.data;
          });

      this.bridgeNotifications = [];

      this.send({
        route: 'b/notification',
        data: {
          bridge: location.host
        }
      }).then((res) => {
            if (res.data.data.length > 0) {
              res.data.data.forEach((n) => {
                if (n.position === 'normal') {
                  this.bridgeNotifications.push(n);
                } else if (n.position === 'popup') {
                  this.setPopup(n);
                }
              });
            }
          });
    },
    setNotification(id) {
      const route = 'notifications/set/read';
      this.send({
        route,
        data: { id }
      })
          .then(() => this.getNotifications());
    },
    setBridgeNotification(id) {
      const route = 'b/notification/r';
      this.send({
        route,
        data: { id }
      })
          .then(() => this.getNotifications());
    },
  },
  data: () => ({
    isFeedBackOpen: false,
    notifications: [],
    bridgeNotifications: [],
    modelData: [],
    bookmark: '',
  }),
  computed: {
    ...mapFields(['loading', 'user', 'holdMyBeer']),
  },
  watch: {
    $route(to) {
      this.bookmark = to.meta.bookmark;
    },
  },
  created() {
    this.getNotifications();
    if (this.bookmark === '') {
      this.bookmark = this.$route.meta.bookmark;
    }
  },
};
</script>

<style scoped>
.non-activated {
  top: 64px;
  width: 300px;
  max-height: calc(100% - 64px);
  position: fixed;
}

.tutbasi {
  font-size: 30px;
  font-weight: 500;
}
</style>
